var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { CalendarContainer, CalendarGrid, GridItemContainer } from './subcomponents';
import getGridItemComponent from '../helpers/get-grid-item-component';
import addOrdinalSuffix from '../../../helpers/add-ordinal-suffix';
import { ENTER_KEY } from '../../../../../const/keyNames';
import { handleKeyDown } from '../helpers/calendar-helpers';
var ComponentName;
(function (ComponentName) {
    ComponentName["NonSelectable"] = "NonSelectable";
    ComponentName["CurrentDueDay"] = "CurrentDueDay";
})(ComponentName || (ComponentName = {}));
var Calendar = function (_a) {
    var currentDueDay = _a.currentDueDay, eligibleDueDays = _a.eligibleDueDays, onSelectDay = _a.onSelectDay, selectedDay = _a.selectedDay;
    var _b = useState(null), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var _c = useState(0), focusedIndex = _c[0], setFocusedIndex = _c[1];
    var gridRef = useRef([]);
    var numbers = Array.from({ length: 28 }, function (_, index) { return index + 1; });
    var ineligibleDays = numbers.filter(function (day) {
        var _a;
        return !((_a = eligibleDueDays === null || eligibleDueDays === void 0 ? void 0 : eligibleDueDays.map(function (item) { return item.eligibleDueDay; })) === null || _a === void 0 ? void 0 : _a.includes(day)) ||
            day === currentDueDay;
    });
    var rowLength = 7;
    var firstEligibleNumber = numbers.find(function (num) { return !ineligibleDays.includes(num); });
    var handleKeyDownWrapper = function (event, index) {
        handleKeyDown({
            event: event,
            index: index,
            row: rowLength,
            numbersLength: numbers.length,
            ineligibleDays: ineligibleDays,
            setFocusedIndex: setFocusedIndex
        });
    };
    var handleSelect = function (index) { return setSelectedIndex(index); };
    useEffect(function () {
        if (firstEligibleNumber)
            setFocusedIndex(firstEligibleNumber - 1);
    }, [firstEligibleNumber]);
    useEffect(function () {
        var _a;
        (_a = gridRef.current[focusedIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    }, [focusedIndex]);
    return (_jsx(CalendarContainer, __assign({ top: "small", bottom: "base", "data-testid": "calendar" }, { children: _jsx(CalendarGrid, __assign({ vertical: "xlarge", id: "calendarList", role: "grid", "aria-label": "calendar grid" }, { children: numbers.map(function (day, index) {
                var _a = getGridItemComponent({
                    day: day,
                    currentDueDay: currentDueDay,
                    eligibleDueDays: eligibleDueDays,
                    selectedDay: selectedDay
                }), GridItem = _a.GridItem, componentName = _a.componentName;
                var date = addOrdinalSuffix(day);
                var currentDueDate = addOrdinalSuffix(currentDueDay);
                var isAriaDisabled = componentName === ComponentName.NonSelectable ||
                    componentName === ComponentName.CurrentDueDay;
                var selectable = componentName === 'Selectable';
                var gridItemAriaLabel = "Choose the ".concat(date, " day of every month");
                if (componentName === 'NonSelectable')
                    gridItemAriaLabel = "The ".concat(date, " day of every month is not available");
                if (componentName === 'CurrentDueDay')
                    gridItemAriaLabel = "The ".concat(currentDueDate, " day of every month is the current payment due date");
                return (_jsx("div", __assign({ role: "row" }, { children: _jsx(GridItemContainer, __assign({ role: "gridcell", "data-testid": "grid-item-".concat(day), tabIndex: index === focusedIndex ? 0 : -1, "aria-current": selectedIndex === index, "aria-disabled": isAriaDisabled, "aria-label": gridItemAriaLabel, "aria-selected": selectable && selectedIndex === index, "aria-rowindex": Math.floor(index / rowLength) + 1, "aria-colindex": (index % rowLength) + 1, ref: function (el) {
                            gridRef.current[index] = el;
                        }, onClick: function () {
                            if (selectable)
                                handleSelect(index);
                            onSelectDay(day);
                        }, onKeyDown: function (event) {
                            if (event.key === ENTER_KEY && selectable) {
                                handleSelect(index);
                                onSelectDay(day);
                            }
                            handleKeyDownWrapper(event, index);
                        } }, { children: _jsx(GridItem, __assign({ "data-testid": "grid-item", "data-cy": componentName }, { children: day })) })) }), day));
            }) })) })));
};
export default Calendar;
